<template>
  <div style="overflow: hidden;hidden: 100vh">
    <img src="../../assets/images/404.png" style="width:100%;height:100vh"/>
  </div>
</template>
<script>
// 404页面
export default {
  name: 'ErrorPage'
}
</script>
